import { useEffect, useState } from 'react';
import { BadgeIcon } from './BadgeIcons';
import { Sparkles } from 'lucide-react';
import './BadgeEarnedModal.css';

/**
 * Full-screen modal shown when the reader earns a new badge.
 * Design: dark translucent backdrop, huge glowing badge crest in the
 * middle, congratulatory Arabic text with graceful sparkles. Auto-close
 * after ~7 seconds or on click.
 */
const BadgeEarnedModal = ({ badge, onClose }) => {
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => finish(), 7000);
    return () => clearTimeout(t);
  }, []);

  const finish = () => {
    setClosing(true);
    setTimeout(() => onClose && onClose(), 350);
  };

  if (!badge) return null;

  return (
    <div className={`badge-earned-overlay ${closing ? 'is-closing' : ''}`} onClick={finish} data-testid="badge-earned-modal">
      <div className="be-backdrop" />
      {/* Floating sparkles */}
      <div className="be-sparks">
        {Array.from({ length: 18 }).map((_, i) => (
          <span
            key={i}
            className="be-spark"
            style={{
              left: `${5 + Math.random() * 90}%`,
              top: `${10 + Math.random() * 80}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${2 + Math.random() * 2.5}s`,
            }}
          />
        ))}
      </div>

      <div className="be-card">
        <div className="be-eyebrow">
          <Sparkles className="w-4 h-4" />
          <span>وسامٌ جديد</span>
          <Sparkles className="w-4 h-4" />
        </div>

        <div className="be-crest">
          <div className="be-crest-glow" />
          <div className="be-crest-icon">
            <BadgeIcon name={badge.icon} />
          </div>
        </div>

        <h2 className="be-name">{badge.name}</h2>
        <p className="be-desc">{badge.description}</p>
        <div className="be-tagline">تباركك المبادرة على هذا الإنجاز الطيّب</div>

        <button type="button" onClick={finish} className="be-btn" data-testid="badge-earned-close">
          واصل الرحلة
        </button>
      </div>
    </div>
  );
};

export default BadgeEarnedModal;
